import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

import { neutral } from "app/themes/colors";

import {
  fieldLabelFromKey,
  formatDetailValue
} from "./processing-events-timeline.utils";

interface AmbientScribeDetailsAccordionProps {
  data: Record<string, unknown>;
}

export default function AmbientScribeDetailsAccordion({
  data
}: AmbientScribeDetailsAccordionProps) {
  const sortedKeys = Object.keys(data).sort();

  return (
    <Accordion disableGutters defaultExpanded={false} sx={{ mb: 2 }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ background: neutral[50] }}
      >
        <Typography variant="body3" fontSize="20px">
          Scribe Details
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, width: "35%" }}>
                Field
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedKeys.map((key) => (
              <TableRow key={key}>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ fontWeight: 500, verticalAlign: "top", width: "35%" }}
                >
                  {fieldLabelFromKey(key)}
                </TableCell>
                <TableCell sx={{ verticalAlign: "top" }}>
                  <Box sx={{ maxHeight: 300, overflowY: "auto" }}>
                    <Typography
                      variant="body2"
                      component="pre"
                      sx={{
                        fontFamily: "monospace",
                        fontSize: "0.75rem",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        m: 0
                      }}
                    >
                      {formatDetailValue(data[key])}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  );
}
